import { useAppDispatch, useAppSelector } from "@store/hooks";
import { Button, Checkbox, DatePicker, Select, TextBox } from "@veneer/core";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { setCurrPayload } from "@store/reducers/search-cases";
import moment from "moment";
import { AdminNotIndividualRole } from "utils";

function CaseSearch(props: any) {
  const [siteAccountList, setSiteAccountList] = useState<any[]>([]);
  const [value, setValue] = React.useState("");
  const [bulkIdValue, setBulkIdValue] = React.useState("");
  const [startDate, setStartDate] = React.useState<any>("");
  const [endDate, setEndDate] = React.useState<any>("");
  const [dateRange, setDateRange] = React.useState<any>("");
  const [onlyCaseID, setOnlyCaseID] = React.useState<boolean>(false);
  const [onlyCaseIDchecked, setOnlyCaseIDchecked] = React.useState<boolean>(false);
  const [onlyBulkID, setOnlyBulkID] = React.useState<boolean>(false);
  const onClear = () => setValue("");
  const { t } = useTranslation();
  const [siteAcountValue, setSiteAcountValue] = React.useState<any[]>([]);
  const [siteAccountValueList, setSiteAccountValueList] = React.useState<any>([]);
  const dispatch = useAppDispatch();
  

  useEffect(() => {
    if (Array.isArray(props.siteSubAccount)) {
      const transformedData = props.siteSubAccount.map((item: any) => ({
        value: item.Key,
        label: item.Value,
      }));
      const withSelectAll = [{value: "-1",label: "Select All"}, ...transformedData]
      const transformedData2 = props.siteSubAccount.map((item: any) => item.Key);
      console.log("transformedData", transformedData2);
      setSiteAccountValueList(transformedData2);
      setSiteAccountList(withSelectAll);
      //setSiteAccountList(transformedData);
    }
  }, [props.siteSubAccount]);

  useEffect(() => {
    // Add the class to the parent element of each item with class "item-1"
    // This will add the class to the parent of each item with class "item-1"
    document.querySelectorAll('.item-1').forEach(item => {
        const parent = item.parentElement;
          if (parent !== null) {
            parent.classList.add('base-base-high-DatePicker');
      }
        });
  }, [])
  

  
  const handleOnDateChange = (newDate: any) => {
     if(true) {
      const { startDate: newStartDate, endDate: newEndDate } = newDate;
      setStartDate(newStartDate);
      setEndDate(newEndDate);
      }
    setDateRange(newDate);
  }
  const onChange = ({ value: selectedValue }: { value: string }) => {
    setSiteAcountValue((prevValue: string[]) => {
      const allOptionValues = siteAccountList.filter((item)=> item.value !== "-1").map((item)=> item.value);
      const isAllSelected = allOptionValues.every((val)=> prevValue.includes(val));
      let newValue: string[] = [];
      if(selectedValue === "-1"){
        return isAllSelected ? [] : [...allOptionValues,"-1"];
      }else {
      const valueCopy = [...prevValue];
      const isOptionSelected = valueCopy.includes(selectedValue);
      if (isOptionSelected) {
          newValue = valueCopy.filter((val)=> val !== selectedValue && val !== "-1")
          
      } else {
          newValue = [ ...valueCopy,selectedValue]
          }
        const isNowAllSelected = allOptionValues.every((val)=> newValue.includes(val));
        return isNowAllSelected ? [...allOptionValues,"-1"] : newValue.filter((v)=> v !== "-1");
      }
    });
  };
  const resetAllFlilter = () => {
    setSiteAcountValue([]);
    setValue("");
    setStartDate("");
    setEndDate("");
    setOnlyCaseID(false);
    setOnlyBulkID(false);
    setOnlyCaseIDchecked(false);
    //props?.resetTbldata();
  };

  const handleSearch = async () => {
    const filteredSiteAccount  = siteAcountValue.filter(val=> val !== "-1")
    try {
      let payload = {};
      if (onlyCaseID) {
        if (value === "") {
          toast.error(t('HPI.ErrorMessage.InputCaseID',{defaultValue:'Please input case id'}));
          return false;
        }
        payload = {
          siteAccount: siteAccountValueList,
          fromDate: "",
          todate: "",
          searchBy:"caseid",
          caseId: value,
          pageNumber: 1,
        };
        (AdminNotIndividualRole) &&( payload = {
          ...payload,
          searchBy:onlyBulkID?"bulkid":"caseid",
        });
        dispatch(setCurrPayload(payload));
        localStorage.setItem("payload", JSON.stringify(payload));
        props.handleRes(payload);
      } else {
        let startDates = startDate.format("YYYY-MM-DD");
        let endDates = endDate.format("YYYY-MM-DD");
         if (filteredSiteAccount.length <= 0) {
          toast.error(t('HPI.ContractWarranties.Cs.PleaseSelect',{defaultValue:'Please select site account'}));
          return false;
        }
        if (startDates === "") {
          toast.error(t('HPI.ErrorMessage.SelectStartDate',{defaultValue:'please select Start date'}));
          return false;
        }
        if (endDates === "" || endDates === undefined || endDates === null) {
          toast.error(t('HPI.ErrorMessage.SelectEndDate',{defaultValue:'please select End date'}));
          return false;
        }
        payload = {
          siteAccount: filteredSiteAccount,
          fromDate: startDates,
          todate: endDates,
          caseId: value,
          searchBy:"caseid",
          pageNumber: 1,
        };
        (AdminNotIndividualRole) &&( payload = {
          ...payload,
           searchBy:onlyBulkID?"bulkid":"caseid",
        });
        dispatch(setCurrPayload(payload));
        localStorage.setItem("payload", JSON.stringify(payload));
        props.handleRes(payload);
      }
    } catch (error) { }
  };
  const handleChekboxChange = (name:string) => {
    if (name === "onlyCaseID") {
      setOnlyCaseIDchecked(!onlyCaseIDchecked);
      if (onlyBulkID) {
        setOnlyBulkID(false);
      }
    } else if (name === "onlyBulkID") {
      setOnlyBulkID(!onlyBulkID);
      
      if (onlyCaseIDchecked) {
        setOnlyCaseIDchecked(false);
      }
    }
    //setValue("");
    // setBulkIdValue("");
  };

  useEffect(() => {
    if (onlyCaseIDchecked || onlyBulkID) {
      setOnlyCaseID(true);
    } else {
      setOnlyCaseID(false);
    }
  }, [onlyCaseIDchecked,onlyBulkID]);
  return (
    <Row className="case-search-container">

      <Col md={12} className="field-container">
        <Select
          multiple
          separateLabel
          disabled={onlyCaseID}
          options={siteAccountList}
          id="Site Account"
          label={t("HPI.MainHomePage.grids.AccountName", {
            defaultValue: "Site Account",
          })}
          placement="bottom"
          placeholder={t("HPI.Dropdown.SelectSiteAccount", {
            defaultValue: "Select Site Account",
          })}
          helperTextVisibility="auto"
          onChange={onChange}
          value={siteAcountValue}
          clearIcon={false}
          className="item"
        />



        <DatePicker
          calendarOrientation={["down"]}
          disabled={onlyCaseID}
          blockFutureDates
          minDate={moment().subtract(1,'year')}
          endDate={endDate}
          label={t('HPI.MainHomePage.Date', { defaultValue: 'Date' })}
          onChange={(newDate: any) => {
            handleOnDateChange(newDate);
          }}
          range
          orientation="horizontal"
          placeholder="MM/DD/YYYY"
          placement="bottom"
          separateLabel
          startDatePlaceholder="MM/DD/YYYY"
          endDatePlaceholder="MM/DD/YYYY"
          startDate={startDate}
          value={dateRange}
          startDateLabel= {t('HPI.MainHomePage.StartDate', { defaultValue: 'Start Date' })}
          endDateLabel= {t('HPI.MainHomePage.EndDate', { defaultValue: 'End Date' })}
          className="item item-1 py-1"
          clearIcon={false}
        />


        <TextBox
          label={AdminNotIndividualRole ?t("HPI.MainHomePage.ByCompanyTab.CaseID", {
            defaultValue: "Case ID",
          })
          
          +' / '+ t("HPI.MainHomePage.ByCompanyTab.BulkId", {
            defaultValue: "Bulk Id",
          })

          :t("HPI.MainHomePage.ByCompanyTab.CaseID", {
            defaultValue: "Case ID",
          })}
          placeholder={AdminNotIndividualRole ?t("HPI.MainHomePage.ByCompanyTab.CaseID", {
            defaultValue: "Case ID",
          })
          
          +' / '+ t("HPI.MainHomePage.ByCompanyTab.BulkId", {
            defaultValue: "Bulk Id",
          })

          :t("HPI.MainHomePage.ByCompanyTab.CaseID", {
            defaultValue: "Case ID",
          })}
          name="caseId"
          value={value}
          separateLabel
          className="item ml-56"
          onChange={(v: string) => {
            setValue(v);
          }}
        />
        
          <Checkbox
          label={AdminNotIndividualRole ?t('HPI.MainHomePage.searchbyCaseId', { defaultValue: 'Search by Case Id' })+ ' / ' +t('HPI.MainHomePage.ByCompanyTab.BulkId', { defaultValue: 'Bulk Id' }) : t('HPI.MainHomePage.ByCompanyTab.searchbyCaseId', { defaultValue: 'Search by Case Id' })} 
          name="onlyCaseID"
          className="check-box-container"
          checked={onlyCaseIDchecked}
          onChange={() => {
            handleChekboxChange("onlyCaseID");
          }}
        />
        
        

        
      </Col>
      

      <Col md={12}>
        <div className="button-container flex-end">
          <Button onClick={resetAllFlilter} appearance="secondary">
            {t('HPI.MainHomePage.clear', { defaultValue: 'Clear' })}
          </Button>
          <Button onClick={handleSearch}>
            {" "}
            {t("HPI.ContractWarranties.btnSearch", { defaultValue: "Search" })}
          </Button>
        </div>

      </Col>

    </Row>
  );
}

export default CaseSearch;